import { AccountantTuple } from 'types';
import { AccountantLookupActions, TYPES } from './actions';

interface AccountantLookupReducerState {
  isLoading: boolean;
  error?: string;
  accountantResults: AccountantTuple[];
}

const initialState: AccountantLookupReducerState = {
  isLoading: false,
  error: '',
  accountantResults: [],
};

export const accountantLookupReducer = (state = initialState, action: AccountantLookupActions): AccountantLookupReducerState => {
  switch (action.type) {
    case TYPES.ACCOUNTANT_LOOKUP:
      return {
        ...state,
        isLoading: true,
        error: '',
      };

    case TYPES.ACCOUNTANT_LOOKUP_SUCCESS:
      return {
        isLoading: false,
        error: '',
        accountantResults: action.payload.accountantResults,
      };

    case TYPES.ACCOUNTANT_LOOKUP_FAILURE:
      return {
        isLoading: false,
        accountantResults: [],
        error: action.payload.error,
      };

    default:
      return state;
  }
};
